import { Lock } from "lucide-react";

const METHODS = ["PayPal", "Carta tramite PayPal", "Bonifico bancario"];

export const PaymentMethods = ({ testid = "payment-methods", className = "" }) => (
  <div data-testid={testid} className={`border border-[rgba(152,191,162,0.25)] bg-[#0b120e] p-6 md:p-7 ${className}`}>
    <p className="flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-[#98bfa2]">
      <Lock size={14} aria-hidden="true" /> Pagamento sicuro
    </p>
    <p className="mt-3 font-display text-2xl font-900 uppercase leading-none text-[#f4f7f5] md:text-3xl">
      Paga <span className="text-[#c4dcca]">come preferisci.</span>
    </p>
    <ul className="mt-5 flex flex-wrap gap-2">
      {METHODS.map((m) => (
        <li key={m} className="border border-[rgba(152,191,162,0.35)] px-3 py-1.5 font-mono text-xs uppercase tracking-wider text-[#f4f7f5]">{m}</li>
      ))}
    </ul>
    <p className="mt-4 text-sm text-[#a3b1aa]">Con PayPal puoi usare il tuo conto PayPal o pagare con carta. Con il bonifico ricevi via email i dati per completare il pagamento.</p>
  </div>
);
